import Api from "../../../services/Api";

export const REQUEST_VIEWER_GAMES = 'REQUEST_VIEWER_GAMES';
export const requestViewerGames = (reset = false, merge = false) => ({
    type: REQUEST_VIEWER_GAMES,
    payload: {
        reset: reset,
        merge: merge,
    }
});

export const RECEIVE_VIEWER_GAMES = 'RECEIVE_VIEWER_GAMES';
export const receiveViewerGames = (games, runningOpenGames, reset = false, merge = false) => ({
    type: RECEIVE_VIEWER_GAMES,
    payload: {
        games: games,
        runningOpenGames,
        reset: reset,
        merge: merge,
    }
});

export const RECEIVE_FAILED_VIEWER_GAMES = 'RECEIVE_FAILED_VIEWER_GAMES';
export const receiveFailedViewerGames = (error) => ({
    type: RECEIVE_FAILED_VIEWER_GAMES,
    payload: {
        error: error,
    }
});

export const UPDATE_VIEWER_GAME_PROPERTIES = 'UPDATE_VIEWER_GAME_PROPERTIES';
export const updateViewerGameProperties = (gameId, properties) => ({
    type: UPDATE_VIEWER_GAME_PROPERTIES,
    payload: { gameId, properties },
});

export const fetchViewerGames = (type, cursor, merge = false) => async (dispatch, getState) => {
    dispatch(requestViewerGames(!cursor, merge))

    const state = getState();
    try {
        const { games, runningOpenGames } = await Api.viewerGames(state.auth.login.accessToken, type, cursor);
        dispatch(receiveViewerGames(games, runningOpenGames, !cursor, merge));
    } catch (e) {
        dispatch(receiveFailedViewerGames({edges: []}));
    }
};